/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Menu,
  Modal,
  Progress,
  Row,
  Spin,
  notification,
} from 'antd';
import getProcesoEnCursoTerminado from 'api/catalogos/ProcesoEnCursoTerminado';
import { formatReceivedValues } from 'utils/formatValues';
import { areaBuscar, normalizeData } from 'utils/normalizers';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import ModalDelete from 'components/ModalDelete';
import ModalSolicitudesPercepcionesEmpleados from 'components/Nominas/SolicitudesPercepciones/ModalSolicitudesPercepcionesEmpleados';
import currencyFormatter from 'utils/currencyFormatter';
import {
  getEstadosGlobales,
  getAreas,
} from 'api/catalogos/index';
import {
  getSolicitudesPercepcionesEmpleados,
  deleteSolicitudPercepcionEmpleado,
  cargarPlantillaSolicitudPercepcion,
  getSolicitudPercepcionPlantillaExcel,
  quitarTodosEmpleadosSolicitudPercepcion,
} from 'api/nominas/solicitudes/solicitudesPercepcionesEmpleados';
import {
  PARAMETRO_AREA,
  PARAMETRO_REEMBOLSOGASTOS,
  PARAMETRO_ESPECIALES,
  ESTATUS_AUTORIZADO,
  PARAMETRO_DESTAJO,
  PARAMETRO_PUESTO,
  PARAMETRO_DEVOLUCION_DESCUENTOS_INDEBIDOS,
  PARAMETRO_RETROACTIVOS_ESPECIFICOS,
  PARAMETRO_ISR_SUBSIDIADO,
} from 'utils/constants';
import { getEmpleadosWithoutFilter } from 'api/estructuraOrganizacional/empleados';
import { getMetodosDePagos } from 'api/catalogos/metodosDePagos';
import { getDatosDePagoDeEmpleados } from 'api/estructuraOrganizacional/datosDePagoDeEmpleados';
import { getPlazas, getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getAdministracionDePlazas, getAdministracionDePlazasvistaOptimized } from 'api/catalogos/admnistracionDePlazas';
import { getPuestos } from 'api/catalogos/puestos';
import { checkToken } from 'api/utils';
import percentFormatter from 'utils/percentFormatter';
import Dragger from 'components/Dragger';
import FormSubmitControls from 'components/FormSubmitControls';
import { DeleteOutlined, FileExcelOutlined, ImportOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx'; // Importar la biblioteca xlsx para generar Excel

export const solicitudesPercepcionesEmpleadosPermission = {
  permissionModel: 'solicitudpercepcionempleado',
  catalogsModels: [],
  tabsModels: [],
};

const baseURI = 'nominas/solicitudes-percepciones-empleados';

const SolcitudesPercepcionesEmpleados = ({
  datosOperacionales,
  permission,
  selected,
  tipoParametro,
  disableColumn,
  disableImportePagar,
  solicitudPercepcion,
  percepcion,
  solicitudConfig,
  requiereLayoutCarga,
  allowControls,
}) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [visibleAlertQuitarTodos, setVisibleAlertQuitarTodos] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [adminPlazas, setAdminPlazas] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [formasDePagos, setFormasDePagos] = useState([]);
  const [metodosDePago, setMetodosDePago] = useState([]);
  const [esPercepcionFijo, setEsPercepcionFijo] = useState(false);
  const [importeSolicitudPagar, setImporteSolicitudPagar] = useState();
  const [visibleCarga, setVisibleCarga] = useState(false);
  const [formCarga] = Form.useForm();

  // Polling — importación Excel en background (igual que Importar Plazas Asignadas)
  const DESCRIPCION_PROCESO_IMPORTAR = 'Importar Solicitudes Percepciones Empleados';
  const [isPollingImport, setIsPollingImport] = useState(false);
  const [progresoImport, setProgresoImport] = useState({ en_curso: 0, total: 0 });
  const pollingImportRef = useRef(null);

  const formatReceivedClone = (values, _datosOperacionales = []) => {
    if (!Array.isArray(values)) {
      return formatReceivedValues(values);
    }

    // Crear diccionario de datosOperacionales usando "empleado" como clave
    const operDict = Object.fromEntries(
      _datosOperacionales.map((d) => [d.empleado, d]),
    );

    return values.map((e) => {
      const base = formatReceivedValues(e);

      // Buscar datos operacionales por id del empleado
      // Buscar by empleado.
      const oper = operDict[base.empleado] || {};

      return {
        ...base,

        numero_empleado: base?.empleado,
        nombre_empleado: base?.empleado,
        puesto_empleado: base?.empleado,
        area_empleado: base?.empleado,
        forma_de_pago_empleado: base?.empleado,

        // Snapshot histórico congelado al momento de la Solicitud (ver CLAUDE.md
        // "Snapshot histórico de campos cascadeados de Plaza") -- se prefiere el valor
        // que ya viene en el propio registro (`base`); `oper` (estado ACTUAL del
        // empleado) solo es respaldo para filas legado sin backfill.
        antiguedad_texto: base?.antiguedad_texto || oper.antiguedad_texto || '',
        antiguedad_numerico_dias: base?.antiguedad_numerico_dias ?? oper.antiguedad_numerico_dias ?? 0,
      };
    });
  };

  const formatReceivedCloneEmpleados = (values, _datosOperacionales = []) => {
    if (!Array.isArray(values)) {
      return formatReceivedValues(values);
    }

    // Crear diccionario de datosOperacionales usando "empleado" como clave
    const operDict = Object.fromEntries(
      _datosOperacionales.map((d) => [d.empleado, d]),
    );

    return values.map((e) => {
      const base = formatReceivedValues(e);

      // Buscar datos operacionales por id del empleado
      const oper = operDict[base.id] || {};

      return {
        ...base,

        no_y_nombre_empleado: `${base?.numero_de_empleado} - ${base?.nombre} ${base?.apellido_paterno} ${base?.apellido_materno || ''}`,
        tipo_nomina_empleado: selected?.tipo_de_nomina_empleado,
        area: base?.id,

        antiguedad_texto: oper.antiguedad_texto || '',
        antiguedad_numerico_dias: oper.antiguedad_numerico_dias || 0,
      };
    });
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getSolicitudesPercepcionesEmpleados({ solicitud_percepcion: selected?.id });
    setData(formatReceivedClone(_data, datosOperacionales));
    setLoading(false);
  };

  const actualizarImporte = () => {
    let importe;
    if (percepcion.importe_diario) {
      importe = percepcion.importe_diario;
      setEsPercepcionFijo(true);
    } else if (percepcion.importe_mensual) {
      importe = percepcion.importe_mensual;
      setEsPercepcionFijo(true);
    } else if (percepcion.importe_fijo_por_evento) {
      importe = percepcion.importe_fijo_por_evento;
      setEsPercepcionFijo(true);
    }
    return importe;
  };

  const onClickCargar = () => {
    setVisibleCarga(true);
  };

  const onCancelCarga = () => {
    setVisibleCarga(false);
    formCarga.resetFields();
  };

  const onUpload = async () => {
    try {
      await formCarga.validateFields();
      const { file } = formCarga.getFieldsValue();

      if (file) {
        setLoading(true);
        const formData = new FormData();
        // El componente Dragger suele devolver el archivo dentro de file.file
        formData.append('archivo', file.file);
        // Agregamos el ID del padre necesario para el backend
        formData.append('solicitud_percepcion_id', selected?.id);

        const response = await cargarPlantillaSolicitudPercepcion(formData);

        // El backend procesa en background y responde { task_id } (202) —
        // cerramos el modal y arrancamos el polling del proceso.
        if (response?.task_id) {
          onCancelCarga();
          setProgresoImport({ en_curso: 0, total: 0 });
          setIsPollingImport(true);
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // Polling — importación Excel en background (cada 2s, máx ~11 min)
  useEffect(() => {
    if (!isPollingImport) return () => {};

    let intentos = 0;
    const maxIntentos = 340;

    pollingImportRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({
          descripcion: DESCRIPCION_PROCESO_IMPORTAR,
        });
        const proceso = lista[0];

        if (proceso) {
          setProgresoImport({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;
        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingImportRef.current);
          pollingImportRef.current = null;
          setIsPollingImport(false);
          setProgresoImport({ en_curso: 0, total: 0 });

          // Descargar el Excel de resultado si existe en proceso.resultado (base64)
          if (proceso?.resultado) {
            const byteCharacters = atob(proceso.resultado);
            const byteArray = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i += 1) {
              byteArray[i] = byteCharacters.charCodeAt(i);
            }
            const blob = new Blob([byteArray], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Solicitud de Percepciones (Carga Masiva).xlsx';
            link.click();
            URL.revokeObjectURL(url);
          }

          notification.success({
            message: 'Importación completada',
            description: 'La carga masiva de empleados finalizó. Se descargó el archivo de resultado.',
            placement: 'topRight',
            duration: 6,
          });
          await fetchData();
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling importación de solicitudes de percepciones] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingImportRef.current) {
        clearInterval(pollingImportRef.current);
        pollingImportRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPollingImport]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _empleados,
        _adminPlazas,
        _plazas,
        _puestos,
        _formasDePago,
        _metodosDePago,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getEmpleadosWithoutFilter(),
        getAdministracionDePlazasvistaOptimized(),
        getPlazasvistaOptimized(),
        getPuestos(),
        getDatosDePagoDeEmpleados(),
        getMetodosDePagos(),
        getSolicitudesPercepcionesEmpleados({ solicitud_percepcion: selected?.id }),
      ]);
      // if (percepcion.es_percepcion_importe_fijo) {
      //   const _solicitudAPagar = await actualizarImporte();
      //   setImporteSolicitudPagar(_solicitudAPagar);
      // }
      if (mounted) {
        setEstados(_estados);
        setEmpleados(formatReceivedCloneEmpleados(
          _empleados,
          datosOperacionales,
        ));
        setAdminPlazas(_adminPlazas);
        setPlazas(_plazas);
        setPuestos(_puestos);
        setFormasDePagos(_formasDePago);
        setMetodosDePago(_metodosDePago);
        setData(formatReceivedClone(_data, datosOperacionales));
        setLoading(false);
      }
    };
    if (selected?.id) {
      fetchAll();
    }
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, [selected?.id]);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setOpen(false);
    form.resetFields();
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteSolicitudPercepcionEmpleado(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setOpen(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onQuitarTodos = () => {
    setVisibleAlertQuitarTodos(true);
  };

  const deleteAllItems = async () => {
    try {
      setLoading(true);
      const result = await quitarTodosEmpleadosSolicitudPercepcion({
        solicitud_percepcion_id: selected?.id,
      });
      if (result !== false) {
        setVisibleAlertQuitarTodos(false);
        onSuccess('Se quitaron todos los empleados de la solicitud.');
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    // Empleado = "No. - Nombre"
    {
      titleText: 'Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 260,
      render: (val) => {
        const emp = empleados.find((e) => e.id === val);
        return (
          emp?.numero_y_nombre_completo
          || (emp ? `${emp.numero_de_empleado} - ${emp.nombre} ${emp.apellido_paterno} ${emp.apellido_materno || ''}`.trim() : '')
        );
      },
    },

    // Snapshot histórico congelado al momento de la Solicitud (ver CLAUDE.md
    // "Snapshot histórico de campos cascadeados de Plaza") -- ya NO se resuelve contra
    // adminPlazas/plazas (estado ACTUAL del empleado), que mostraba la Plaza vigente hoy
    // en vez de la que tenía al momento de la Solicitud.
    {
      titleText: 'Plaza',
      dataIndex: 'plaza_clave_y_descripcion',
      key: 'plaza_clave_y_descripcion',
      width: 220,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 220,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area_clave_y_nombre',
      key: 'directorio_de_area_clave_y_nombre',
      width: 260,
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado_descripcion',
      key: 'tipo_de_nomina_empleado_descripcion',
      width: 220,
    },
    {
      titleText: 'Tipo de Empleado',
      dataIndex: 'tipo_empleado_descripcion',
      key: 'tipo_empleado_descripcion',
      width: 220,
    },
    {
      titleText: 'Importe de Solicitud',
      dataIndex: 'importe_de_solicitud',
      key: 'importe_de_solicitud',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
      disable: disableColumn,
    },
    {
      titleText: 'Aplica Porcentaje de Pago',
      dataIndex: 'aplica_porcentaje_de_pago',
      key: 'aplica_porcentaje_de_pago',
      width: 250,
      render: (val) => (val ? 'Si' : 'No'),
      disable: disableColumn,
    },
    {
      titleText: 'Porcentaje de Pago',
      dataIndex: 'porcentaje_de_pago',
      key: 'porcentaje_de_pago',
      width: 200,
      render: (val) => percentFormatter(val || 0),
      disable: disableColumn,
    },
    {
      titleText: 'Importe de Solicitud a Pagar',
      dataIndex: 'importe_de_solicitud_a_pagar',
      key: 'importe_de_solicitud_a_pagar',
      width: 250,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
      disable: disableImportePagar,
    },
    {
      titleText: 'Forma de Pago',
      dataIndex: 'forma_de_pago_empleado',
      key: 'forma_de_pago_empleado',
      width: 200,
      render: (val, record) => {
        if (record.forma_de_pago_descripcion) return record.forma_de_pago_descripcion;
        const _empleado = empleados.find((e) => e.id === val);
        const _formaPago = formasDePagos.find((e) => e.empleado === _empleado?.id);
        return metodosDePago.find((e) => e.id === _formaPago?.metodo_de_pago)?.concepto;
      },
    },
    {
      titleText: 'Antigüedad',
      dataIndex: 'antiguedad_texto',
      key: 'antiguedad_texto',
      width: 200,
    },
    {
      titleText: 'No. de Días',
      dataIndex: 'antiguedad_numerico_dias',
      key: 'antiguedad_numerico_dias',
      width: 200,
      render: (value) => Number(value).toLocaleString('es-MX'),
    },
    {
      titleText: 'Importe Base',
      dataIndex: 'importe_base',
      key: 'importe_base',
      width: 250,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe por Pagar',
      dataIndex: 'importe_de_solicitud_a_pagar',
      key: 'importe_de_solicitud_a_pagar',
      width: 250,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const columnsISR = [
    {
      titleText: 'Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 260,
      render: (val) => {
        const emp = empleados.find((e) => e.id === val);
        return (
          emp?.numero_y_nombre_completo
          || (emp ? `${emp.numero_de_empleado} - ${emp.nombre} ${emp.apellido_paterno} ${emp.apellido_materno || ''}`.trim() : '')
        );
      },
    },
    // Snapshot histórico congelado al momento de la Solicitud (ver CLAUDE.md
    // "Snapshot histórico de campos cascadeados de Plaza") -- ya NO se resuelve contra
    // adminPlazas/plazas (estado ACTUAL del empleado).
    {
      titleText: 'Plaza',
      dataIndex: 'plaza_clave_y_descripcion',
      key: 'plaza_clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area_clave_y_nombre',
      key: 'directorio_de_area_clave_y_nombre',
      width: 200,
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado_descripcion',
      key: 'tipo_de_nomina_empleado_descripcion',
      width: 200,
    },
    {
      titleText: 'Tipo de Empleado',
      dataIndex: 'tipo_empleado_descripcion',
      key: 'tipo_empleado_descripcion',
      width: 200,
    },
    {
      titleText: 'Sueldo Promedio',
      dataIndex: 'sueldo_promedio', //
      key: 'sueldo_promedio',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Aguinaldo',
      dataIndex: 'aguinaldo',
      key: 'aguinaldo',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Anticipo',
      dataIndex: 'anticipo',
      key: 'anticipo',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Fecha de Pago del Anticipo',
      dataIndex: 'fecha_pago_anticipo',
      key: 'fecha_pago_anticipo',
      width: 220,

    },
    {
      titleText: 'Diferencia',
      dataIndex: 'diferencia',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Días Equivalentes',
      dataIndex: 'dias_equivalentes',
      key: 'dias_equivalentes',
      width: 130,
      align: 'center',
    },
    {
      titleText: 'ISR Subsidiado',
      dataIndex: 'isr_subsidiado',
      key: 'isr_subsidiado',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'ISR del Empleado',
      dataIndex: 'isr_empleado',
      key: 'isr_empleado',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe por Pagar',
      dataIndex: 'importe_de_solicitud_a_pagar',
      key: 'importe_de_solicitud_a_pagar',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 120,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const activeColumns = (tipoParametro === PARAMETRO_ISR_SUBSIDIADO)
    ? columnsISR
    : columns;
    // Función para obtener plantilla en backend
    // const onClickObtenerPlantilla = async () => {
    // try {
    //  setLoading(true);
    //  const excel = await getSolicitudPercepcionPlantillaExcel();

  //  if (excel) {
  //    const blob = new Blob([excel], {
  //      type: 'application/ms-excel',
  //    });
  //    const url = URL.createObjectURL(blob);
  //    const link = document.createElement('a');
  //    link.href = url;
  //    // Nombre del archivo que se descargará
  //   link.download = 'Plantilla_Solicitud_Percepcion.xlsx';
  //    link.click();

  // Limpieza
  //    window.URL.revokeObjectURL(url);
  //  }

  // Función para generar la plantilla Excel en el frontend (versión simplificada)
  const generateExcelTemplate = () => {
    try {
      const wb = XLSX.utils.book_new();

      const templateData = [
        ['Num EMP', 'Importe Pago'],
      ];

      const ws = XLSX.utils.aoa_to_sheet(templateData);

      const headerStyle = {
        font: {
          bold: true, // Texto en negrita
          sz: 15, // Tamaño de fuente
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
        },
      };

      ['A1', 'B1'].forEach((cell) => {
        if (!ws[cell]) ws[cell] = { t: 's', v: '' };
        ws[cell].s = headerStyle;
      });

      ws['!cols'] = [
        { wch: 20 }, // Columna A más ancha
        { wch: 20 }, // Columna B más ancha
      ];

      // Ajustar alto de filas
      ws['!rows'] = [
        { hpt: 30 }, // (encabezados)
        { hpt: 15 }, // (datos)
      ];

      XLSX.utils.book_append_sheet(wb, ws, 'Carga Masiva');

      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = 'Plantilla_Solicitud_Percepcion.xlsx';

      link.click();

      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      throw new Error('No se pudo generar la plantilla');
    }
  };

  const onClickObtenerPlantilla = async () => {
    try {
      setLoading(true);
      // Generar plantilla localmente en lugar de hacer petición al backend
      generateExcelTemplate();

      // Notificar éxito
      onSuccess('Plantilla descargada correctamente');
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const menuImport = (
    <Menu
      items={[
        {
          key: '1',
          label: 'Obtener Plantilla',
          icon: <FileExcelOutlined />, // Icono de Excel
          onClick: onClickObtenerPlantilla, // Llamada a la función
        },
        {
          key: '2',
          label: 'Cargar Layout',
          icon: <ImportOutlined />,
          onClick: onClickCargar,
        },
      ]}
    />
  );
  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={activeColumns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickDelete,
          }}
          customActions={[
            {
              text: 'Importar',
              icon: <ImportOutlined />,
              onClick: onClickCargar,
              // visible: requiereLayoutCarga && allowControls,
              className: 'primary',
              disabled: !allowControls,
            },
            {
              text: 'Quitar Todos',
              icon: <DeleteOutlined />,
              onClick: onQuitarTodos,
              className: 'no-color danger',
              disabled: !allowControls || data.length === 0,
            },
          ]}
          allowCustomImport={allowControls}
          customImportMenu={menuImport}
          customImportText="Importar Solicitud"
          baseURI={baseURI}
          permission={permission}
          addText="Agregar Empleado"
          deleteText="Quitar Empleado"
          allowExportPDF={false}
          allowAdd={allowControls}
          allowDelete={allowControls}
        />
        <ModalSolicitudesPercepcionesEmpleados
          datosOperacionales={datosOperacionales}
          empleados={empleados}
          solicitud={selected?.solicitud}
          tipoNominaEmpleado={selected?.tipo_de_nomina_empleado}
          periodoNominaDetalle={selected?.periodo_de_nomina_detalle}
          solicitudPercepcion={selected?.id}
          solicitudesPercepcionesEmpleados={data}
          percepcionFijo={esPercepcionFijo}
          solicitudConfig={solicitudConfig}
          importeSolicitudPagar={importeSolicitudPagar}
          tipoParametro={tipoParametro}
          puestos={puestos}
          open={open}
          setOpen={setOpen}
          onSave={fetchData}
        />
        <Modal
          open={visibleCarga}
          title={(
            <FormSubmitControls
              label="Carga Masiva"
              onFinish={onUpload}
              onCancel={onCancelCarga}
              loading={loading}
            />
          )}
          onCancel={onCancelCarga}
          footer={null}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          forceRender
          destroyOnClose
        >
          <Spin tip="Cargando..." spinning={loading}>
            <Form
              layout="vertical"
              form={formCarga}
              name="carga"
              onFinish={onUpload}
            >
              <Dragger
                label="Archivo"
                limitMB={30} // Puedes ajustar el límite
                rules={[{ required: true, message: 'El archivo es requerido' }]}
                name="file"
                allowedExtensions={['xlsx', 'xls']}
              />
            </Form>
          </Spin>
        </Modal>
        {/* MODAL : PROGRESO IMPORTACIÓN EXCEL */}
        <Modal
          open={isPollingImport}
          title="Importando Empleados..."
          footer={null}
          closable={false}
          maskClosable={false}
          centered
        >
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <Progress
              type="circle"
              percent={
                progresoImport.total > 0
                  ? Math.round((progresoImport.en_curso / progresoImport.total) * 100)
                  : 0
              }
            />
            <p style={{ marginTop: 16 }}>
              {progresoImport.en_curso}
              {' / '}
              {progresoImport.total}
              {' registros procesados'}
            </p>
          </div>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Empleado ${empleados.find((e) => e.id === form.getFieldValue('empleado'))?.numero_de_empleado || ''}`}
          loading={loading}
        />
        <ModalDelete
          onDelete={deleteAllItems}
          onCancel={() => setVisibleAlertQuitarTodos(false)}
          open={visibleAlertQuitarTodos}
          content={`todos los ${data.length} empleado(s) de la solicitud`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default SolcitudesPercepcionesEmpleados;
